module.exports = __webpack_public_path__ + "img/tienda-10.130ab0cc.png";